import React from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'

import './TransfertPaymentContent.css'

const TransfertPaymentContent = ({ t, walletIban, isRecurring }) => {
  const {iban, bic} = walletIban
  if (isRecurring) {
    return <div className="transfert-container">
      <span>{t('common:payment:transfert:recurring_instruction')}</span>
      <ul className="transfert-list">
        <li>{t('common:payment:transfert:iban', { iban })}</li>
        <li>{t('common:payment:transfert:bic', { bic })}</li>
      </ul>
    </div>
  }
  return (
    <div className='transfert-container'>
      <span>{t('common:payment:transfert:iban', { iban })}</span>
      <span>{t('common:payment:transfert:bic', { bic })}</span>
    </div>
  )
}

TransfertPaymentContent.propTypes = { t: func }

export default translate()(TransfertPaymentContent)



// WEBPACK FOOTER //
// ./src/components/customer/wallet/payments/transfert/TransfertPaymentContent.js